/**
 * ActivationPaymentsCustomChargeCtrl controller
 */

/**
 * ActivationPaymentsCustomChargeCtrl controller
 *
 * @class ActivationPaymentsCustomChargeCtrl
 * @memberof mwApp/subscribers
 * @see mwApp/subscribers
 * @mixes mwApp/common.mixin:m2mCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/subscribers.controller:ActivationPaymentsCustomChargeCtrl
 */
/* @ngInject */
export default function ActivationPaymentsCustomChargeCtrl (scope) {
  var vm = this

  /**
   * Return blank payment request
   * When user changes payment type, for exmple, we need new blank payment request, without old data
   *
   * @function
   */
  const getBlankPaymentRequest = (defaults = {}) => ({
    comment: null,
    ...defaults
  })

  /**
   * Blank for PaymentRequest
   *
   * @memberof mwApp/subscribers.controller:ActivationPaymentsCustomChargeCtrl
   * @type {Object}
   */
  let payment = vm.payment = getBlankPaymentRequest()

  /*
   * Get part of payment from child view
   */
  scope.getChildPayment = (forProcessing) =>
    forProcessing
      ? payment
      : undefined
}
